import { createApi } from '@reduxjs/toolkit/query/react';

import { JimboResponse, ActivityLog } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const activityLogApi = createApi({
  reducerPath: 'activityLogApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['activityLogApi'],
  endpoints: (builder) => ({
    getCustomerLogs: builder.query<ActivityLog[], { customerId: string }>({
      query: (query) => `/activity-log/customer-logs/${query.customerId}`,
      providesTags: ['activityLogApi'],
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transformResponse: (response: JimboResponse<ActivityLog[]>) => response.data!,
    }),
  }),
});

export const { useGetCustomerLogsQuery } = activityLogApi;
